import React, { useEffect, useState } from "react";
import PageHeader from "../../components/common/MagicPageHeader";
import Stack from "../../components/mui/Stack";
import Table from "../../components/common/MagicTable";
import Button from "../../components/mui/Button";
import Sidebar from "../../components/common/MagicDrawer_new";
import { SubmitHandler, useForm } from "react-hook-form";
import ImageComponent from "../../components/mui/Image";
import AddIcon from "@mui/icons-material/Add";
import {
  useGetManageAwardQuery,
  useManageAwardCreateMutation,
  useManageAwardEditMutation,
  useManageAwardDeleteMutation,
} from "../../store/apis/configurationApis";
import { ManageAwardAftParser } from "../../store/types/configuration";
import AwardAddForm from "../../components/configuration/forms/AwardAddForm";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Text from "../../components/mui/Text";
import Box from "../../components/mui/Box";
import Modal from "../../components/common/Modal";
import { showToast } from "../../helper/toaster";
import usePermission from "../../helper/usePermission";
import { acl } from "../../helper/userAccessConstant";

const ManageAward: React.FC = () => {
  const [isOpenEditSidebar, setIsOpenEditSidebar] = useState<boolean>(false);
  const [isOpenAddSidebar, setIsOpenAddSidebar] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const selector = useSelector((state: RootState) => state?.user?.filter);

  const [params, setParams] = useState({
    pageNo: "1",
    pageSize: "10",
    programMasterId: selector?.selectedProgram?.value,
    quarterMasterId: selector?.selectedQuarter?.quarterMasterId,
    ProgramYearId: selector?.selectedYear?.value,
  });
  const [selectedData, setSelectedData] = useState<any>([]);

  const { permissions } = usePermission();

  const { canRead, canWrite, canUpdate, canDelete } =
    permissions[acl.configuration.module]?.manage_award;

  const toggleEditSidebar = () =>
    setIsOpenEditSidebar((prevState) => !prevState);

  const toggleAddSidebar = () => setIsOpenAddSidebar((prevState) => !prevState);
  const toggleDeleteModal = () =>
    setIsDeleteModalOpen((prevState) => !prevState);
  const handleDeleteModal = (data: any) => {
    setSelectedData(data);
    toggleDeleteModal();
  };

  // api call start
  const [addAward, { isLoading: iscreatingAward }] =
    useManageAwardCreateMutation();
  const [editAward, { isLoading: iseditingAward }] =
    useManageAwardEditMutation();
  const [deleteAward] = useManageAwardDeleteMutation();

  const {
    data: awardData,
    isLoading,
    error,
    refetch,
  } = useGetManageAwardQuery(params);
 
  const {
    handleSubmit: handleEditFormSubmit,
    control: editFormControl,
    formState: editFormState,
    reset: resetEditForm,
  } = useForm({
    defaultValues: {
      awardName: "",
      points: {},
      pointInPercentage: "",
      leaderBoardCount: "",
    },
  });

  const {
    handleSubmit: handleAddFormSubmit,
    control: addFormControl,
    reset: resetAddForm,
  } = useForm({
    defaultValues: {
      awardName: "",
      points: "",
      pointInPercentage: "",
      leaderBoardCount: "",
    },
  });

  const operatorOptions = [
    { id: "<", label: "Less Than" },
    { id: "<=", label: "Less Than or Equal To" },
    { id: ">", label: "Greater Than" },
    { id: ">=", label: "Greater Than or Equal To" },
    { id: "==", label: "Equal To" },
    { id: "!=", label: "Not Equal To" },
    { id: "&&", label: "And" },
    { id: "||", label: "Or" },
  ];

  const findOperator = (operator: string) => {
    const foundOperator = operatorOptions.find(
      (item: any) => item.id === operator
    );
    return { label: foundOperator?.label, id: foundOperator?.id };
  };

  const handleAddFormDoneBtn: SubmitHandler<any> = async (data) => {
    const addPayload = {
      body: {
        awardName: data?.awardName,
        operator: data?.points?.id,
        point: data?.pointInPercentage,
        leadCount: data?.leaderBoardCount,
        programMasterId: selector?.selectedProgram?.value || undefined,
        quarterMasterId:
          selector?.selectedQuarter?.quarterMasterId || undefined,
        ProgramYearId: selector?.selectedYear?.value || undefined,
      },
    };

    try {
      const res = await addAward(addPayload);
      if (res?.data?.success) {
        showToast(
          res?.data?.message || "Manage award added successfully",
          "success"
        );
        resetAddForm();
        toggleAddSidebar();
        refetch();
      }
    } catch (error) {
      console.error("Error adding new award:", error);
    }
  };

  const onDelete = async () => {
    try {
      const res = await deleteAward({ id: selectedData?.manageAwardId });
      toggleDeleteModal();
      refetch();
      if (res.data?.success) {
        if (awardData?.tableRowData?.length === 1) {
          setParams((prevParams: any) => ({
            ...prevParams,
            pageSize: "10",
            pageNo: Math.max(prevParams.pageNo - 1, 1),
          }));
        }
        showToast(
          res?.data?.message || "Manage award delete successfully",
          "success"
        );
      }
    } catch (error) {
      console.error("Error deleting award:", error);
    }
  };

  const handleEditFormDoneBtn: SubmitHandler<any> = async (data) => {
    const editPayload = {
      id: selectedData?.manageAwardId,
      body: {
        awardName: data?.awardName,
        operator: data?.points?.id,
        point: data?.pointInPercentage,
        leadCount: data?.leaderBoardCount,
      },
    };

    try {
      const response = await editAward(editPayload);
      if (response?.data) {
        resetEditForm();
        toggleEditSidebar();
        refetch();
        showToast(
          response?.data?.message || "Manage award edited successfully",
          "success"
        );
      }
    } catch (error) {
      console.error("Error editing award:", error);
    }
  };

  const handleEditBtnClick = (data: any) => {
    console.log({data})
    setSelectedData(data);
    setIsOpenEditSidebar((prevState) => !prevState);

    resetEditForm({
      awardName: data?.awardName || "",
      points: findOperator(data?.operator) || "",
      pointInPercentage: data?.point || "",
      leaderBoardCount: data?.leadCount || 0,
    });
  };

  const onPageChange = async (event: any, page: number) => {
    setParams((prev) => ({
      ...prev,
      pageSize: "10",
      pageNo: page.toString(),
    }));
  };

  useEffect(() => {
    setParams((prev) => ({
      ...prev,
      programMasterId: selector?.selectedProgram?.value,
      quarterMasterId: selector?.selectedQuarter?.quarterMasterId,
      ProgramYearId: selector?.selectedYear?.value,
    }));
  }, [selector]);

  const columns = [
    {
      field: "awardName",
      headerName: "Award",
      flex: 1,
    },
    {
      field: "point",
      headerName: "Points",
      flex: 1,
    },
    {
      field: "leadCount",
      headerName: "Leader board",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (props: { row: any }) => {
        return (
          <Stack
            flexDirection={"row"}
            sx={{ display: "flex", alignItems: "center" }}
            gap={1}
          >
            <Button
              variant="outlined"
              sx={{
                border: "1px solid #EAECF0",
                padding: "9px 0px !important",
                borderRadius: "12px",
                minWidth: "45px",
              }}
              disabled={!canUpdate}
              onClick={() => handleEditBtnClick(props?.row)}
            >
              <ImageComponent
                src="/assets/images/icon/editIcon.svg"
                alt="editPen"
              />
            </Button>
            <Button
              variant="outlined"
              sx={{
                border: "1px solid #EAECF0",
                padding: "9px 0px !important",
                borderRadius: "12px",
                minWidth: "45px",
              }}
              disabled={!canDelete}
              onClick={() => handleDeleteModal(props?.row)}
            >
              <ImageComponent
                src="/assets/images/icon/delete.svg"
                alt="editPen"
              />
            </Button>
          </Stack>
        );
      },
    },
  ];

  const headerBtn = [
    {
      text: "New award",
      variant: "contained",
      startIcon: <AddIcon />,
      onClick: toggleAddSidebar,
      sx: {
        backgroundColor: "#FFF1B7",
        border: "1px solid #997906",
        borderRadius: "8px",
        fontWeight: "600",
        boxShadow: "none",

        "&:hover": {
          boxShadow: "none",
        },
      },
    },
  ];

  const tableRowData =
    (awardData as ManageAwardAftParser | undefined)?.tableRowData || [];
  const tableRowCount =
    (awardData as ManageAwardAftParser | undefined)?.totalRowCount || 0;

  const totalPages = Math.ceil(tableRowCount / 10);

  return (
    <Stack>
      <PageHeader
        title="Manage award"
        subTitle="Here you can view and edit all the award details."
        chipLabel={`${tableRowCount} awards`}
        buttons={canWrite ? headerBtn : []}
      />

      <Table
        columns={columns}
        rows={tableRowData}
        rowCellsSx={{ paddingLeft: "10px", textAlign: "start" }}
        headerSx={{
          textAlign: "start",
          fontWeight: 600,
          color: "#242424",
          padding: "13px 0px 13px 10px",
        }}
        getRowId={(row: any) => row.manageAwardId}
        tableSx={{ minHeight:"300px" ,  width: "100%" }}
        handlePageChange={onPageChange}
        count={totalPages || 1}
        currentPage={Number(params?.pageNo) || 1}
        loading={isLoading}
        sx={{
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#DADADA",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
          },
        }}
      />

      <Modal open={isDeleteModalOpen} disableClose={true}>
        <>
          <Box
            padding={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "12px",
              flexDirection: "column",
            }}
          >
            <Box height={"50px"}>
              <ImageComponent src="/assets/images/icon/warning.svg" />
            </Box>
            <Text
              sx={{ color: "#101828", fontWeight: "600", fontSize: "18px" }}
            >
              Are you sure you want to delete this?
            </Text>
            <Text
              sx={{
                color: "#667085",
                fontSize: "14px",
                fontWeight: "400",
                textAlign: "center",
              }}
            >
              By clicking on the Delete button you are making sure that you want
              to delete this permanently.
            </Text>

            <Stack flexDirection={"row"} width={"100%"} gap="15px">
              <Button
                variant="contained"
                sx={{
                  flex: 1,
                  borderRadius: "8px",
                  border: "1px solid #8D8D8D",
                  backgroundColor: "#fff",
                  "&:hover": {
                    backgroundColor: "#ededed",
                  },
                }}
                onClick={toggleDeleteModal}
              >
                No
              </Button>
              <Button
                sx={{
                  flex: 1,
                  borderRadius: "8px",
                  border: "1px solid #a18218",
                  backgroundColor: "#fef7da",
                  "&:hover": {
                    backgroundColor: "#e8d78e",
                  },
                }}
                onClick={onDelete}
              >
                delete
              </Button>
            </Stack>
          </Box>
        </>
      </Modal>

      <Sidebar
        title={`Edit Platinum Award`}
        subtitle="Here you can edit award details."
        drawerOpen={isOpenEditSidebar}
        onDrawerToggle={toggleEditSidebar}
        width="418px"
        actionComponent={() => (
          <>
            <Button className="bun-outline" onClick={toggleEditSidebar}>
              Cancel
            </Button>
            <Button
              className="bun-filled"
              loading={iseditingAward}
              onClick={handleEditFormSubmit(handleEditFormDoneBtn)}
            >
              Done
            </Button>
          </>
        )}
      >
        <AwardAddForm
          control={editFormControl}
          formState={editFormState}
          operatorOptions={operatorOptions}
        />
      </Sidebar>

      <Sidebar
        title="New Award"
        subtitle="Here you can add new award."
        drawerOpen={isOpenAddSidebar}
        onDrawerToggle={toggleAddSidebar}
        width="418px"
        actionComponent={() => (
          <>
            <Button className="bun-outline" onClick={toggleAddSidebar}>
              Cancel
            </Button>
            <Button
              className="bun-filled"
              loading={iscreatingAward}
              onClick={handleAddFormSubmit(handleAddFormDoneBtn)}
            >
              Done
            </Button>
          </>
        )}
      >
        <AwardAddForm
          control={addFormControl}
          operatorOptions={operatorOptions}
        />
      </Sidebar>
    </Stack>
  );
};

export default ManageAward;
